<div class="text-center text-disabled">
  <div class="material-symbols-outlined not-found-icon">screen_search_desktop</div>
  <div class="text-not-found">{{labelPaginaNoEncontrada}}</div>
</div>

